/**
 * The layout-route element: the shell, keyed by chat scope.
 *
 * ShellProvider captures its storage scope once at mount (D6/D8), so an
 * identity change (uid or impersonated org) must remount the whole shell,
 * chat included. Mounted inside ProtectedRoute so auth has resolved.
 */
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useImpersonation } from '../contexts/ImpersonationContext';
import { buildChatScope } from '../utils/chatHistoryStore';
import AppShell from './AppShell';
import { ShellProvider } from './ShellProvider';

export const ShellRoot: React.FC = () => {
  const { user } = useAuth();
  const { orgId } = useImpersonation();
  const scope = buildChatScope(user?.uid, orgId === null ? null : String(orgId)) ?? 'anon';
  return (
    <ShellProvider key={scope}>
      <AppShell />
    </ShellProvider>
  );
};

export default ShellRoot;
